import { render, staticRenderFns } from "./editAlert.vue?vue&type=template&id=5a55e83e&"
import script from "./editAlert.vue?vue&type=script&lang=js&"
export * from "./editAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports